import { usePermissao } from "@/lib/use-permissao";
import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { PrazoDeProducaoSection } from "@/components/organization/PrazoDeProducaoSection";
import { TaxaDeUrgenciaSection } from "@/components/organization/TaxaDeUrgenciaSection";
import { CabecalhoDaOrganizacao } from "@/components/organization/dados/CabecalhoDaOrganizacao";
import { CartaoDeContato } from "@/components/organization/dados/CartaoDeContato";
import { CartaoDeEndereco } from "@/components/organization/dados/CartaoDeEndereco";
import { BlocoDeDados, BotaoSalvar } from "@/components/organization/dados/BlocoDeDados";

// ─── Seção "Dados da organização" (logo, nome, CNPJ, contato, endereço) ─

export function DadosSecao() {
  const meQuery = trpc.me.current.useQuery();
  const activeOrganization = meQuery.data?.activeOrganization;
  // A mesma régua do servidor (settings.manage) — dono e sócio sempre têm.
  const canManage = usePermissao("settings.manage");
  // Taxa é dinheiro: segue a permissão de preços, não a de configurações.
  const podePrecos = usePermissao("prices.manage");
  const ehLab = (activeOrganization?.types ?? []).includes("DENTAL_LAB");

  return (
    <div className="space-y-5 px-6 py-5">
      <CabecalhoDaOrganizacao canManage={canManage} />
      {/* Organização pessoal leva o nome da pessoa (muda em Minha conta); o resto é igual. */}
      {!activeOrganization?.isPersonal && <NomeDaOrganizacao canManage={canManage} />}
      <CartaoDeContato canManage={canManage} />
      <CartaoDeEndereco canManage={canManage} />
      {ehLab && (
        <BlocoDeDados>
          <PrazoDeProducaoSection canManage={canManage} />
        </BlocoDeDados>
      )}
      {ehLab && podePrecos && (
        <BlocoDeDados>
          <TaxaDeUrgenciaSection />
        </BlocoDeDados>
      )}
    </div>
  );
}

function NomeDaOrganizacao({ canManage }: { canManage: boolean }) {
  const utils = trpc.useUtils();
  const atual = trpc.me.current.useQuery().data?.activeOrganization?.name ?? "";
  const [name, setName] = useState<string | null>(null);
  const valor = name ?? atual;

  const updateName = trpc.organization.updateName.useMutation({
    onSuccess: () => {
      utils.me.current.invalidate();
      utils.organization.getProfiles.invalidate();
      utils.organization.listMine.invalidate();
      toast.success("Nome da organização atualizado.");
      setName(null);
    },
    onError: (err) => toast.error(err.message || "Erro ao atualizar o nome."),
  });

  return (
    <div data-tour="config-organizacao-nome">
      <BlocoDeDados titulo="Nome da organização" descricao="Como a organização aparece no menu, nos pedidos e para os parceiros.">
        <Input id="clinic-name" aria-label="Nome da organização" value={valor} onChange={(e) => setName(e.target.value)} disabled={!canManage} minLength={2} maxLength={120} />
        {canManage && (
          <BotaoSalvar
            onClick={() => updateName.mutate({ name: valor })}
            disabled={updateName.isPending || name === null || valor.trim().length < 2}
            salvando={updateName.isPending}
          />
        )}
      </BlocoDeDados>
    </div>
  );
}
